module.exports = __webpack_public_path__ + "img/head-end-cover.77f38351.jpg";